// extracted by mini-css-extract-plugin
export var deliveryRow = "_l1-a";
export var fixedHeight = "_l1-4";
export var freightLogo = "_l1-9";
export var fullWidth = "_l1-3";
export var priceColumn = "_l1-5";
export var radioSelected = "_l1-7";
export var radioUnselected = "_l1-6";
export var selectedOption = "_l1-2";
export var selectedOptionContainer = "_l1-1";
export var selection = "_l1-0";
export var tallSkeletonText = "_l1-8";